module.exports = __webpack_public_path__ + "static/img/meau.3eba390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meau.png
// module id = QiUh
// module chunks = 53